import { IAutoMapper } from "../interfaces";

export const mapWorkflowStatusModel = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "WorkflowStatusModel")
    .forMember("workflowStatusId", o => o.workflowStatusId)
    .forMember("workflowStatusName", o => o.workflowStatusName);
};
